module.exports = __webpack_public_path__ + "static/media/Sign_out.d59c4c0f.svg";